export const CCtaBoxFragments = {
  field: `
    fragment ctaBox on ctaBox_MatrixField {
      ... on ctaBox_block_Entry {
        id
        typeHandle
        idName
        backgroundImage {
          url @transform(mode: "crop", width: 2000, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        backgroundImageMobile {
          url @transform(mode: "crop", width: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        theme
        label
        heading
        buttonText
        hyperlink {
          type
          url
          text
          target
        }
      }
    }
  `,
  customComponentsBlogField: `
    fragment customComponentsBlog_ctaBox on customComponentsBlog_MatrixField {
      ... on customComponentsBlog_ctaBox_Entry {
        id
        typeHandle
        idName
        backgroundImage {
          url @transform(mode: "crop", width: 2000, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        backgroundImageMobile {
          url @transform(mode: "crop", width: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        theme
        label
        heading
        buttonText
        hyperlink {
          type
          url
          text
          target
        }
      }
    }
  `,
}
